module.exports = "https://www.gc-pro.gnp.com.mx/7b23ff88aba204874fcd6af85797aff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/informacion-exitoso2.png
// module id = 8141
// module chunks = 0